import React from 'react';
import DashboardLayout from '../components/layout/DashboardLayout';

const TestRequestGuide: React.FC = () => {
  return (
    <DashboardLayout>
      <div className="p-4">
        <div className="card bg-white rounded-sm p-4 border border-slate-300">
          <h2 className="text-lg font-bold text-slate-800 mb-4">پک راهنمای ثبت درخواست آزمایش</h2>
          <p className="text-slate-600 mb-4">
            در این بخش راهنمای کامل ثبت درخواست آزمایش را مشاهده می‌کنید.
          </p>
          
          <div className="mb-4">
            <h3 className="text-md font-semibold text-slate-700 mb-2">مراحل ثبت درخواست آزمایش</h3>
            <ol className="list-decimal list-inside text-slate-600 space-y-2">
              <li>وارد صفحه "درخواست آزمایش جدید" شوید</li>
              <li>اطلاعات شخصی مورد نیاز را تکمیل کنید</li>
              <li>نوع آزمایش مورد نظر را انتخاب کنید</li>
              <li>زمان مراجعه به آزمایشگاه را تعیین کنید</li>
              <li>پیش‌پرداخت را انجام دهید</li>
              <li>کد پیگیری را دریافت و نگهداری کنید</li>
            </ol>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default TestRequestGuide;
